export default __webpack_public_path__ + "static/media/MDG.9927828e.png";